import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Business, License } from 'src/model/business';
import { Customer } from 'src/model/customer.model';
import { FormJ } from 'src/model/formJ.model';
import { PaymentSchedule } from 'src/model/paymentSchedule.model';
import { BusinessService } from 'src/services/business.service';
import { CustomerService } from 'src/services/customer.service';
import { FormJService } from 'src/services/form-j.service';

@Component({
	selector: 'app-form-j',
	templateUrl: './form-j.component.html',
	styleUrls: ['./form-j.component.scss'],
	standalone: false
})
export class FormJComponent implements OnInit {
	private activatedRoute = inject(ActivatedRoute);
	protected sharedService = inject(SharedService);
	private customerService = inject(CustomerService);
	private enums = inject(Enums);
	private formJService = inject(FormJService);
	private businessService = inject(BusinessService);

	// selectedCompany: Company;
	// selectedCompanyID: number;
	selectedCustomer: Customer;
	selectedCustomerID: number;
	selectedFormJID: number;
	currentLicenseID: number;
	selectedFormJ: FormJ;
	routeSubscription: any;
	paymentScheduleList: PaymentSchedule[] = [];
	principal: number;
	lastPayment: number;
	selectedBusiness: Business;
	selectedBusinessLicense: License;

	@ViewChild('htmlData') htmlData: ElementRef;

	constructor() {
		this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
			this.selectedCustomerID = +params.get('customerId');
			this.selectedFormJID = +params.get('formJId');
			this.getData();
			// this.getCustomerInfo();
			// await this.getFormJInfo();
			// await this.getLicenseInfo();
			// this.getBusinessInfo();
		});
	}

	ngOnInit(): void {}

	async getData() {
		[this.selectedCustomer, this.selectedFormJ] = await Promise.all([
			this.customerService.getCustomerDetails(this.selectedCustomerID),
			this.formJService.getFormJDetails(this.selectedFormJID)
		]);
		const isLegacy = this.selectedFormJ.LicenseId === this.enums.LEGACY_BUSINESS_LICENSE_ID;
		if (isLegacy) {
			this.selectedBusinessLicense = await this.businessService.getLatestLicenseByCustomerId(this.selectedCustomerID);
			this.selectedBusiness = await this.businessService.getBusiness(this.selectedBusinessLicense.BusinessId);
		} else {
			[this.selectedBusiness, this.selectedBusinessLicense] = await Promise.all([
				this.businessService.getBusiness(this.selectedFormJ.BusinessId),
				this.businessService.getLicense(this.selectedFormJ.LicenseId)
			]);
		}
	}

	calculateFirstPayment(stampDate: Date) {
		return new Date(new Date(stampDate).getFullYear(), new Date(stampDate).getMonth() + 1, new Date(stampDate).getDate());
	}

	processPaymentSchedule(scheduleList: any) {
		const paymentScheduleList: PaymentSchedule[] = [];
		scheduleList.forEach(schedule => {
			const payment = { monthsCount: schedule.monthsCount, amount: schedule.amount };
			paymentScheduleList.push(payment);
		});
		return scheduleList;
	}

	print() {
		window.print();
	}
}
